<div id="main" class="d-flex align-items-center justify-content-center">
  <router-outlet></router-outlet>
</div>
<div class="clear"></div>
